import React from 'react'
import Modal from 'react-modal'
import {
  XIcon,
  ExclamationCircleIcon,
  CheckCircleIcon,
} from '@heroicons/react/24/solid'
import styles from './EnrollFree.module.css'
import buttonStyles from './buttons.module.css'

// following the modal setup in
// https://devrecipes.net/modal-component-with-next-js/

Modal.setAppElement('#modal-root')

function EnrollFree(props) {
  const [isBrowser, setIsBrowser] = React.useState(false)
  const [modalIsOpen, setIsOpen] = React.useState(false)
  const [email, setEmail] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState(false)
  const [submitted, setSubmitted] = React.useState(false)

  // do nothing on the server
  React.useEffect(() => {
    setIsBrowser(true)
  }, [])
  if (!isBrowser) {
    return null
  }

  function openModal() {
    setIsOpen(true)
  }

  function closeModal() {
    setIsOpen(false)
    setEmail('')
    setLoading(false)
    setError(false)
    setSubmitted(false)
  }

  function hasEmail() {
    return email && email.length > 0
  }

  async function handleSubmit(event) {
    // TODO: change to Next.js API function
    // const url = '/.netlify/functions/enroll'
    const url = '/api/courses/enroll/free'
    setLoading(true)
    try {
      const { status } = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, courseId: props.courseId }),
      })
      setSubmitted(true)
      if (status !== 200) {
        setError(true)
      }
    } catch (err) {
      setSubmitted(true)
      setError(true)
      console.log(err)
    }
    setLoading(false)
    event.preventDefault()
  }
  function Content() {
    if (submitted) {
      if (error) {
        console.log(styles)
        return (
          <div
            className={`${styles.ReactModal__Content_alert} ${styles.ReactModal__Content_alert_error}`}
          >
            <ExclamationCircleIcon />
            <span>Submission failed. Please try again later.</span>
          </div>
        )
      } else {
        return (
          <div
            className={`${styles.ReactModal__Content_alert} ${styles.ReactModal__Content_alert_success}`}
          >
            <CheckCircleIcon />
            <span>
              Success! Please check your email to activate your course.
            </span>
          </div>
        )
      }
    } else {
      return (
        <div>
          <p className={styles.ReactModal__Content_p}>
            Please enter your email address to enroll in this course.
          </p>
          <div className={styles.ReactModal__Content_form}>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              type="email"
              name="email"
              placeholder="Your email"
              autoFocus
              required
            />
            <button
              className={`${buttonStyles.button} ${buttonStyles.primary}`}
              onClick={handleSubmit}
              disabled={!hasEmail()}
            >
              <span>Submit</span>
              <span className={loading ? 'loading' : ''} />
            </button>
          </div>
        </div>
      )
    }
  }
  return (
    <span>
      <span
        onClick={openModal}
        className={`${buttonStyles.button} ${buttonStyles.primary}`}
      >
        {props.text}
      </span>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Enroll"
        className={styles.ReactModal__Content}
        overlayClassName={styles.Overlay}
      >
        <div className={styles.ReactModal__Content_close}>
          <XIcon onClick={closeModal} />
        </div>
        <Content />
      </Modal>
    </span>
  )
}

export default EnrollFree
